/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import ko from 'knockout';
import {context} from '../../../objects/context.js';
import $ from 'jquery';
import _ from 'lodash';
import 'froala-editor';
import 'knockout-froala';
import axios from 'axios';
import {saveAs} from 'file-saver';
import htmlDocx from '../../../../node_modules/html-docx-js/dist/html-docx';
import jobUtil from '../../../objects/jobUtil';
import jobVersionObj from '../../../objects/jobVersionObj';
import optionsUtil from '../../../objects/optionsUtil.js';
import editorStyleObj from '../../../objects/editorStyleObj.js';

import BootstrapDialog from 'bootstrap3-dialog/dist/js/bootstrap-dialog';


class editorInlineModel {

    constructor(params) {
        // Profile
        this.componentName = "tabEditor";

        this.context = context;
        this.mode = ko.observable(params.mode);
        this.messageObj = params.messageObj;

        this.saveFormState = ko.observable(false);
        this.saveFormVisible = ko.observable(false);
        this.saveFormComments = ko.observable("");
        this.saveFormStatus = ko.observable();
        this.saveFormStatusArray = [{label:"Approved",value:8},{label:"Approved w/Changes",value:10},{label:"Rejected",value:12}];

        this.title = params.selectedJob.title;

        this.selectedJob = params.selectedJob;
        this.selectedVersion = ko.observable();
        this.currentReviewObj = {};

        this.id = this.context.util.guid();
        this.visible = ko.observable(true);
        this.editorVisible = ko.observable(true);

        this.componentMessenger = ko.observable({componentName:"job-history",visible:false, selectedJob: this.selectedJob });

        //this.reviewView = ko.observable(false);
        //this.standardView = ko.observable(true);

        this.buttonBarVisible = ko.observable(false);

        this.froalaInstance = ko.observable();

        this.froalaInstance.subscribe( (returnObj) => {

            console.log("tabEditor:init froalaInstance.subscribe: returnObj: %o", returnObj);

            //returnObj.edit.off();

            returnObj.events.on('froalaEditor.initialized', (e) => {
                console.log("tabEditor:froalaEditor.initialized: initialized: %o", e);
            });
            

         });

        this.froalaStyle = "";

        //froala editor body
        this.editorBody = params.selectedJob.body;
        this.jobguid = params.selectedJob.jobguid;
        this.statusid = params.selectedJob.statusid;

        this.options = ko.observable({});

          $('#' + this.id).on('froalaEditor.initialized', function (e, editor) {
            //console.log("tabEditor Init.");
          });

          this.init();

    }

    init() {
            console.log("tabEditor: init: mode: %o", this.mode());
            console.log('tabEditor:init context.profileObject().disableExpertOptions', context.profileObject().disableExpertOptions);

            //Set up Editor
            if(context.profileObject().disableExpertOptions)
            {
                /* Options Disabled */
                this.options({theme: 'gray',
                    saveMethod: 'POST',
                    saveParam: 'content',
                    quickInsertButtons: ['image', 'table','ul','ol','hr'],
                    quickInsertTags: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote'],
                    paragraphStyles: this.context.styleSheet(),
                    inlineStyles: this.context.inLineStyleFormatted(),
                    initOnClick: true,
                    toolbarInline: false,
                    pluginsEnabled: ['save','print','draggable','colors','entities','table','paragraphFormat','alert','align','bold','lists', 'italic', 'underline', 'codeView','wordPaste', 'customPlugin', 'codeBeautifier','fontFamily','fontSize','fullscreen']
                });
                        
            }
            else
            {
                this.options({theme: 'gray',
                    saveMethod: 'POST',
                    saveParam: 'content',
                    quickInsertButtons: ['image', 'table','ul','ol','hr'],
                    quickInsertTags: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote'],
                    paragraphStyles: this.context.styleSheet(),
                    inlineStyles: this.context.inLineStyleFormatted(),
                    initOnClick: true,
                    toolbarInline: false,
                    pluginsEnabled: ['save','print','draggable','colors','entities','table','paragraphFormat','alert','align','bold','lists', 'italic', 'underline', 'codeView','wordPaste', 'customPlugin', 'codeBeautifier','fontFamily','fontSize','inlineStyle', 'fullscreen']
                });
            }

            //Update Stlyes for Export
            this.updateStyle();

            //let self = this;
            if( _.isNumber(parseInt(this.selectedJob.jobid())) )
            {
                this.getVersion();
            }

            this.saveFormState.subscribe( status => {
                
                if(status)
                {
                    this.saveFormVisible(true);
                }
                else
                {
                    this.saveFormVisible(false);
                }

            });

            this.saveFormStatus.subscribe( () => {
               //console.log(this.saveFormStatus());
            });

            this.messageObj.subscribe( messageObj =>  {

                console.log("tabEditor:messageObj:subscribe: messageObj: %o", messageObj);
                
                switch(messageObj.event)
                {

                    case "getVersion":
                        console.log("tabEditor:init");
                        if(messageObj.reviewObj)
                        {
                            this.currentReviewObj = messageObj.reviewObj;
                        }
                        
                        this.getVersion(messageObj.jobid);

                        break;
                }

            });

    }


    debug() {

        console.log("params.selectedJob.body:");
        console.log(this.jobguid);
        console.log(this.editorBody());
    }

    toggleEditorVisible()
    {
        this.editorVisible(!this.editorVisible());

        if(this.editorVisible())
        {
            this.componentMessenger({componentName:"job-history",visible:false});
        }
        else
        {
            this.componentMessenger({componentName:"job-history",visible:true});
        }
    }
    
    editorClick() {
        console.log('Editor Click');
        this.buttonBarVisible(true);
        //this.froalaInstance().editable();
    }

    /*
    edit() {
        console.log("tabEditor:edit");
        $('#' + this.id).froalaEditor('destroy');
        $('#' + this.id).froalaEditor(this.options);
    }
    */

    importJob() {

        console.log("tabEditor:Import Job: selectedJob: %o", this.selectedJob);
        this.context.eventManager.notifySubscribers({callingComponent: this},"Show JDM-Modal");
        //$('#jdmModal').modal('show');
    }

    /*
    clickSave() {

        console.log("click: Save");
        console.log(this.froalaInstance());
        console.log(this.id);
        //this.froalaInstance().off('froalaEditor.initialized');
        $('#' + this.id).froalaEditor('destroy');

        $('#' + this.id).froalaEditor(this.options);
        this.buttonBarVisible(false);

        //$('#50d35d6e-98d6-c296-41ff-9510897a8a8b').off('froalaEditor.initialized');
    }
    */

    updateOptions() {

        console.log("tabEditor:Update Options");

        this.options = ko.observable({
            // disable wrapping content with paragraphs
            // instead <br> will be used
            //enter: $.FroalaEditor.ENTER_DIV,
            //
            // we like gray!
            theme: 'gray',
            paragraphStyles: this.context.styleSheet(),
            inlineStyles: {
                'Big Red': 'font-size: 20px; color: red;',
                'Small Blue': 'font-size: 14px; color: blue;',
                'Added Style': 'font-size: 14px; color: blue;'
              },
            initOnClick: true,
            toolbarInline: false,
            pluginsEnabled: ['alert','align','bold', 'italic', 'underline', 'codeView','wordPaste', 'customPlugin', 'codeBeautifier','paragraphStyle','fontFamily','fontSize','inlineStyle', 'fullscreen']
          });

          $('#' + this.id).froalaEditor(this.options);
    }

    addTasks() {

        //debug: let url = this.context.resultsUrl + 'pageRequest' + '?XDEBUG_SESSION_START=PHPSTORM';
        let url = this.context.ONetUrl + 'occupations/17-2051.00/summary/tasks?display=long&client=blr';

        axios({
            url: url,
            method: 'post',
            headers: this.context.resultsContentType
        }).then((response) => {
            console.log(response.data);
            //this.handleGetResults(response.data);
            //this.resultsHTML(response.data);
        }).catch((error) =>{
            console.log("tabEditor:addTasks: Error: %", error);
            this.context.eventManager.notifySubscribers({title:"API Error",message:"Error getting content"},"messageModel");
        });
    }

    saveVersion() {

        console.log("tabEditor:saveVersion selectedVersion: %o", this.selectedVersion());
        console.log(this.selectedVersion());
        let jobUtilObj = new jobUtil(this.context);

        /*
        try {
            this.selectedVersion().data = this.saveFormComments();
        }
        catch(err)
        {
            let newVersion = new jobVersionObj();
            this.selectedVersion(new jobVersionObj() );
            this.selectedVersion().updateWithJob(this.selectedJob);
        }
        */
        
        this.selectedVersion().data = this.editorBody();
        this.selectedVersion().notes = this.saveFormComments();
        
        if(this.context.loginStatusObj().Mode == "Review")
        {   this.selectedVersion().jdmuserid = this.currentReviewObj().jdmUserID;
            this.selectedVersion().reviewId = this.currentReviewObj().reviewId;
            this.selectedVersion().statusid = this.saveFormStatus();
        }
        
        jobUtilObj.saveJobVersion(this.selectedVersion).then((response) => {
            
            console.log("tabEditor:saveVersion");
            console.log(response);
            //this.saveFormVisible(false);

            // Update Job
            this.selectedJob.refreshThisJob(this.context);

            this.saveFormState(false);

            if(this.context.loginStatusObj().Mode == "Review")
            {
                BootstrapDialog.show({
                    title: 'Thank you',
                    message: 'The page will now refresh and this review will be unavailable . If you have another review click that link in your email.',
                    type: BootstrapDialog.TYPE_SUCCESS,
                    onhidden: function(dialogRef){
                        location.reload();
                    }
                });
                
            }

        }).catch( (response) => {
            console.log("tabEditor:saveVersion ERROR: %o", response);
            
            
        });

    }

    clickAddJdmClass() {

        $('#' + this.id + ' .fr-wrapper .fr-element').children().each(
            function() {
                console.log("jobUtil:addJdmClass: this: %o", this);
                console.log("tabEditor:addCSSClassRecursively: children: %o", this);
                 $(this).addClass("jdm");
                 //addCSSClassRecursively($(this), CssClass);
            });
    }

    processResponseAddJdmClass(contentData) {

        $(contentData).children().each(
            function() {
                //console.log("tabEditor:processResponseAddJdmClass: this: %o", this);
                 $(this).addClass("jdm");
                 //addCSSClassRecursively($(this), CssClass);
            });

        return contentData;
    }

    getVersion(jobid) {

        let isnum = /^\d+$/.test(jobid);
        let self = this;

        if(isnum)
        {
            let jobUtilObj = new jobUtil(this.context);
            
            jobUtilObj.getJobVersion(parseInt(jobid)).then((response) => {
                
                console.log("tabEditor:getVersion");
                console.log(response);

                if(response !== undefined)
                {
                    this.editorBody(this.processResponseAddJdmClass(response.data));
                    this.selectedVersion(new jobVersionObj(response));
                    //console.log("tabEditor:getVersion: selectedVersion: %o", selectedVersion);
                    
                }
                else
                {
                    //let newVersion = new jobVersionObj();
                    //this.selectedVersion(newVersion.updateWithJob(this.selectedJob));
                    console.log("tabEditor:getVersion No version found");
                }

                /*
                $('#' + this.id).each(function(i, item) {
                    let $item = $(item);
                    console.log("jobUtil:addJdmClass: item: %o", $item);
                    $item.addClass('jdm');
                    console.log("jobUtil:addJdmClass: item after: %o", $item);
                });
                */

                

                //elf.addCSSClassRecursively($('#' + self.id), 'jdm');

            });
        }
        else
        {
            console.log("tabEditor:getVersion called by jobid was not a number: " + jobid + " : " + _.isNumber(parseInt(jobid)) );
        }
        
    }

    displaySaveForm(item) {
        //this.saveFormState(true);
        console.log('tabEditor:displaySaveForm item: %o', item);
        this.context.eventManager.notifySubscribers(item,"save-job-modal");

        //this.froalaInstance().destroy();

    }

    saveFormHandler(event, state)
    {
        console.log("saveHandler");
        console.log(event);
        console.log(state);
        let self = this;
        
    }

    cancelSaveForm() {
        this.saveFormState(false);
    }

    updateStyle() {

        let oUtil = new optionsUtil(this.context);

        this.froalaStyle = "";
        let self = this;


        oUtil.getMasterStyles().then( (result) => {
            //self.context.masterStyleSheet(result);
            ko.utils.arrayForEach(result, (item) => {

                //console.log("tabEditor:updateStyle item: %o, formatted style: %s", item);
    
                let tempStyle = new editorStyleObj(item);

                //console.log("tabEditor:updateStyle getCleanStyle style: %s", tempStyle.getCleanStyle());

                this.froalaStyle += tempStyle.getCleanStyle();

            });

            //console.log("tabEditor:updateStyle Final style: %o", this.froalaStyle);
  
        });

        /*
        this.froalaStyle = 'h1.jdm { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; } ';
        this.froalaStyle += 'h3.jdm { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; } ';
        this.froalaStyle += 'p.jdm { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; } ';
        this.froalaStyle += 'li.jdm { list-style-type: none; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; }  ';
        this.froalaStyle += 'ul.jdm { list-style-type: none; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; } ';
        */
    }


    getBodyWithStyleSheet() {
        
        let retnHtml = "";

        retnHtml = "<!DOCTYPE html><html>";
        retnHtml += "<head>";
        retnHtml += "<meta charset=UTF-8>";
        retnHtml += "<title>" + this.selectedJob.title() + "</title>";
        retnHtml += "<style>" + this.froalaStyle + "</style>";
        retnHtml += "</head>";

        retnHtml += "<body class='jdm'><div class='fr-view'>" + this.editorBody() + "</div></body>";
        console.log("tabEditor:getBodyWithStyleSheet:   html: %o", retnHtml);


        return retnHtml;
            
    }


    exportToPdfSave() {

        let url = this.context.generateApiUrl('/JobVersions/pdf');
        let callData = JSON.stringify({ jobid: this.selectedJob.jobid(), subid: this.context.subid(), body: this.getBodyWithStyleSheet()});

        $.ajax({
            url: url,
            method: "POST",
            headers: this.context.apiContentType,
            crossDomain: true,
            data: callData
        })
        .done((data, textResponse, request) => {
            let url = this.context.apiEntryPointPdf + "/" + this.context.subid() + "/" + this.selectedJob.jobid() + ".pdf";
            console.log("tabEditor:exportToWord: exportToPdf: done: %o  url: %o", data, url);
            
            
                // Get file name from url.
                var filename = this.selectedJob.title();
                var xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = function() {
                  var a = document.createElement('a');
                  a.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
                  a.download = filename; // Set the file name.
                  a.style.display = 'none';
                  document.body.appendChild(a);
                  a.click();
                  a = null;
                };
                xhr.open('GET', url);
                xhr.send();
              
              
        })
        .fail((responseData, textStatus, errorThrown) => {
            this.context.eventManager.notifySubscribers({modalTitle:"PDF Error",modalBody:"Error calling exportToPdf"},"messageModel");
            //reject(responseData);
        });

        //http://jdmapi.blr.com/pdf/done/900423599/117898.pdf
        
    }

    exportToPdfView() {

        let url = this.context.generateApiUrl('/JobVersions/pdf');
        let callData = JSON.stringify({ jobid: this.selectedJob.jobid(), subid: this.context.subid(), body: this.getBodyWithStyleSheet()});

        $.ajax({
            url: url,
            method: "POST",
            headers: this.context.apiContentType,
            crossDomain: true,
            data: callData
        })
        .done((data, textResponse, request) => {
            let url = this.context.apiEntryPointPdf + "/" + this.context.subid() + "/" + this.selectedJob.jobid() + ".pdf";
            console.log("tabEditor:exportToWord: exportToPdf: done: %o  url: %o", data, url);
              
            window.open(url, '_blank', 'location=no,scrollbars=yes,status=yes');
        })
        .fail((responseData, textStatus, errorThrown) => {
            this.context.eventManager.notifySubscribers({modalTitle:"PDF Error",modalBody:"Error calling exportToPdf"},"messageModel");
            //reject(responseData);
        });
        
    }

    exportToHtml() {

        let text = this.getBodyWithStyleSheet();
        let filename = $("#input-fileName").val()
        let blob = new Blob([text], {type: "text/plain;charset=utf-8"});
        saveAs(blob, this.selectedJob.title() + ".html");
    }

    exportToWordHtml() {
        let text = this.getBodyWithStyleSheet();
        let filename = $("#input-fileName").val()
        let blob = new Blob([text], {type: "application/msword;charset=utf-8"});
        saveAs(blob, this.selectedJob.title() + ".docx");
    }

    exportToWord() {
        console.log("tabEditor:exportToWord: ");
        let wordHtml = this.getBodyWithStyleSheet();
        console.log("tabEditor:exportToWord: wordHtml: %o", wordHtml);
        let wordExport = htmlDocx.asBlob(wordHtml, {orientation: 'portrait', margins: {top: 200}});
        saveAs(wordExport, this.selectedJob.title() + '.docx');
    }

    froalaSave() {
        console.log("tabEditor:froalaSave: ");
        //$('#' + this.id).froalaEditor({saveMethod: 'POST'}, {saveURL: this.context.generateApiUrl('/JobVersions/pdf')});
        $('#' + this.id).froalaEditor({saveParams: {
            JobID: this.selectedJob.jobid(),
            title: this.selectedJob.title()
          }
        });

        $('#' + this.id).froalaEditor('save.save');
    }

}

export default { viewModel: editorInlineModel, template: require('!raw-loader!./tabEditor.html') };


// WEBPACK FOOTER //
// ./src/components/nav-job-list/tabEditor/tabEditor.js